/**
 * @file routes/_app/dashboard.tsx
 * @description 工作台路由（角色分流，Task 62 實作詳細工作台卡片）。
 *
 * 根據當前登入用戶的角色渲染對應的工作台組件：
 * - admin   → AdminWorkbench
 * - manager → ManagerWorkbench
 * - decider → DeciderWorkbench
 * - auditor → AuditorWorkbench
 */

import { createFileRoute } from '@tanstack/react-router';
import { useAuthStore } from '@/lib/auth-context';
import { AdminWorkbench } from '@/components/workbench/AdminWorkbench';
import { ManagerWorkbench } from '@/components/workbench/ManagerWorkbench';
import { DeciderWorkbench } from '@/components/workbench/DeciderWorkbench';
import { AuditorWorkbench } from '@/components/workbench/AuditorWorkbench';

/** 路由定義 */
export const Route = createFileRoute('/_app/dashboard')({ component: Dashboard });

/**
 * 工作台容器。
 * 依角色分流到對應的工作台組件，保持頁面路由統一為 /dashboard。
 */
function Dashboard() {
  const role = useAuthStore((s) => s.user!.role);
  switch (role) {
    case 'admin':
      return <AdminWorkbench />;
    case 'manager':
      return <ManagerWorkbench />;
    case 'decider':
      return <DeciderWorkbench />;
    case 'auditor':
      return <AuditorWorkbench />;
    // 驗證組長（序59）暫無專屬工作台，回落稽核員視圖（其主要入口為合約評審簽名）
    case 'verification_lead':
      return <AuditorWorkbench />;
    // 會計（序52）暫無專屬工作台，回落管理組視圖（其主要入口為派案專區的報價／繳費管理）
    case 'accountant':
      return <ManagerWorkbench />;
    default:
      return <AuditorWorkbench />;
  }
}
